export function calculatePercentage(lo, hi, signScale) {
  const scaledLo = parseFloat(lo) / Math.pow(10, signScale);
  const scaledHi = parseFloat(hi) / Math.pow(10, signScale);

  return scaledHi !== 0 ? (scaledLo / scaledHi) * 100 : 0;
}
